// Phone (design v2): a horizontal shelf of the artists you follow — round
// faces with names, one tap opens the artist page. Shown on the Library hub
// and on the empty search screen, the way Spotify fills both with "your"
// things instead of a blank page.
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveSearch, setArtistQuery } from '../../redux/slices/djpalSlice';
import { searchArtist } from '../../redux/thunk/djpalThunk';
import { setActiveTab } from '../../redux/slices/appSlice';
import { track } from '../../utils/analytics';
import CoverArt from '../CoverArt';

const MAX = 12;

export function useOpenFollowedArtist(from) {
    const dispatch = useDispatch();
    return useCallback((a) => {
        track('artist_opened', { artist_id: a.artist_public_id || undefined, artist_name: a.artist_name, from });
        // Sub-tab + query BEFORE setActiveTab so the nav marker is typed and
        // the result replaces it (one Back = back here) — FollowedArtistsSidebar.
        dispatch(setActiveSearch('artist'));
        dispatch(setArtistQuery(a.artist_name));
        dispatch(setActiveTab('djpal'));
        dispatch(searchArtist({ artistName: a.artist_name, artistId: a.artist_public_id || null, artworkUrl: a.artwork || null }));
    }, [dispatch, from]);
}

const YourArtistsShelf = ({ label = 'Your artists', from, onOpened }) => {
    const artists = useSelector((s) => s.followedArtists?.artists || []);
    const open = useOpenFollowedArtist(from);
    if (!artists.length) return null;
    return (
        <section className="v2-your-artists" aria-label={label}>
            <h4 className="v2-your-artists-title">{label}</h4>
            <div className="v2-your-artists-row">
                {artists.slice(0, MAX).map((a) => (
                    <button
                        key={a.artist_name}
                        type="button"
                        className="v2-your-artist"
                        onClick={() => { open(a); if (onOpened) onOpened(); }}
                    >
                        {a.artwork
                            ? <CoverArt src={a.artwork} size={160} className="v2-your-artist-face" />
                            : <span className="v2-your-artist-face is-letter">{(a.artist_name || '?').charAt(0).toUpperCase()}</span>}
                        <span className="v2-your-artist-name">{a.artist_name}</span>
                    </button>
                ))}
            </div>
        </section>
    );
};

export default YourArtistsShelf;
